import * as React from "react";
import { styled } from "@mui/system";
import MUIDialogTitle from "@mui/material/DialogTitle";
import {
  DialogTitleProps as DialogTitlePropsMUI,
  DialogTitleTypeMap
} from "@mui/material/DialogTitle";
import { OverridableComponent } from "@mui/material/OverridableComponent";
export interface DialogTitleProps extends DialogTitlePropsMUI {
  component?: React.ElementType;
}

const DialogTitleRoot = styled(MUIDialogTitle, {
  name: "DialogTitle",
  slot: "Root",
  overridesResolver: (props, styles) => []
})(({ theme }) => ({
  "&.MuiDialogTitle-root": {
    ...theme.typography["titleSmall"],
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: 16,
    paddingBottom: 16,
    paddingLeft: 24,
    paddingRight: 16
  }
}));

export const DialogTitle = React.forwardRef<HTMLSpanElement, DialogTitleProps>(
  function DialogTitle(props, ref) {
    return <DialogTitleRoot {...props} ref={ref} />;
  }
) as OverridableComponent<DialogTitleTypeMap<{}, "span">>;
